import React from 'react';

import { Icon } from '@/components/memo';
import { useSubscription } from '@/contexts';
import { PLAN_DESCRIPTIONS, PLAN_NAMES } from '@/utils/subscriptions';
import { checkmarkCircle, ellipseOutline } from 'ionicons/icons';

import './Plans.css';

const Plans: React.FC = () => {
  const { plans, selectedPlan, setSelectedPlan } = useSubscription();

  const copy = {
    badge: 'MOST POPULAR'
  };

  return (
    <div className="plans">
      {plans.map((plan, index) => (
        <div
          key={plan.identifier}
          className={`plan ${selectedPlan?.identifier === plan.identifier ? 'plan--selected' : ''}`}
          onClick={() => setSelectedPlan(plan)}
        >
          {index === 1 && <p className="plan__badge">{copy.badge}</p>}
          <div className="plan__header">
            <Icon
              className="plan__icon"
              icon={
                selectedPlan?.identifier === plan.identifier
                  ? checkmarkCircle
                  : ellipseOutline
              }
              color={
                selectedPlan?.identifier === plan.identifier
                  ? 'primary'
                  : 'medium'
              }
            />
            <h1 className="plan__title">{PLAN_NAMES[plan.identifier]}</h1>
          </div>
          <p className="plan__description">
            {PLAN_DESCRIPTIONS[plan.identifier]}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Plans;
